import { Grid, Table, TableBody, TableCell, TableContainer, TableRow, Theme, useMediaQuery } from '@material-ui/core';
import React, { useCallback, useContext, useMemo } from 'react';

import Button from 'Common/Button';

import { PhysicalCheckContext } from '../../physical-check.context';

export default function ListPhysicalCheck() {
  const { loading, physicalChecks, setEditDialogOpened } = useContext(PhysicalCheckContext);
  const largerThanMd = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
  const buttonContainerClassName = useMemo(() => (largerThanMd ? 'pl-4 text-right' : 'pl-4'), [largerThanMd]);
  const openEditDialog = useCallback(() => setEditDialogOpened(true), [setEditDialogOpened]);

  return (
    <>
      <Grid container>
        <Grid item sm={12} md={12} lg={12}>
          {!!physicalChecks && !loading && (
            <>
              <TableContainer className="ml-2">
                <Table size="small">
                  <TableBody>
                    {physicalChecks.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell style={{ width: '30%' }} align="left">
                          {item.physicalCheckDefinitionName}
                        </TableCell>
                        <TableCell style={{ width: '10%' }} align="left">
                          <Button
                            className="text-white text-bold"
                            style={{ backgroundColor: item.color, width: '100%' }}
                            variant="contained"
                            disabled>
                            {item.valueText}
                          </Button>
                        </TableCell>
                        <TableCell align="left" style={{ width: '60%', textAlign: 'justify' }}>
                          {item.description}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}
          <div style={{ marginTop: '10px' }} className={buttonContainerClassName}>
            <Button onClick={openEditDialog} color="secondary" variant="contained">
              Fizik Muayene Düzenle
            </Button>
          </div>
        </Grid>
      </Grid>
    </>
  );
}
